import React from 'react';
import { Create, SelectInput, SimpleForm, TextInput } from 'react-admin';
import { CustomDateInput } from '../../../../commonComponents/CustomDateInput';
import { statuses } from '../../../../config/constants';
import QuestionForm from './QuestionForm';

const QuizCreate = (props) => (
  <Create title="Create Quiz" {...props}>
    <SimpleForm redirect="list">
      <TextInput label="Name" source="name" />
      <CustomDateInput label="Activates at" source="activated_at" />
      <SelectInput source="status" optionText="name" choices={statuses.slice(0, 2)} />
      <QuestionForm name="questions" populate />
    </SimpleForm>
  </Create>
);

export default QuizCreate;
